<template>
  <div>
    <h1 class="p-lg">ComboBox</h1>
    <div
      class="p-lg mb-lg bg-whiteOverride"
      style="height: 28rem"
    >
      <div class="flex gap-base">
        <div class="w-full">
          <h2>Default</h2>

          <ComboBox
            v-model="value"
            :options="options"
            data-ec=""
            data-et=""
          />
        </div>

        <div class="w-full">
          <h2>Open</h2>

          <ComboBox
            v-model="value"
            :options="options"
            class="is-open is-active force-open"
            data-ec=""
            data-et=""
          />
        </div>
      </div>

      <div
        v-if="value"
        class="w-full my-lg"
      >
        Selected value: {{ JSON.stringify(value, null, 2) }}
      </div>
    </div>

    <div class="p-lg mb-lg bg-whiteOverride">
      <div class="flex gap-base">
        <div class="w-full">
          <h2>With action</h2>

          <ComboBox
            v-model="value"
            :options="options"
            placeholder="Start typing title to search for a Lorem Ipsum"
            noResults="Can't find that mate"
            data-ec=""
            data-et=""
          >
            <template v-slot:action="{ option }">
              <BaseButton
                variant="invisible"
                size="medium"
                class="whitespace-nowrap !py-sm !px-base hover:!text-dark3 !no-underline hover:!underline"
                @click.native="handleDelete($event, option)"
              >
                Remove
              </BaseButton>
            </template>
          </ComboBox>
        </div>
        <div class="w-full">
          <h2>Narrow</h2>

          <ComboBox
            v-model="value"
            :options="options"
            placeholder="Start typing title to search for a Lorem Ipsum"
            noResults="Can't find that mate"
            class="w-1/2"
            data-ec=""
            data-et=""
          >
            <template v-slot:action="{ option }">
              <BaseButton
                variant="invisible"
                size="medium"
                class="whitespace-nowrap !py-sm !px-base hover:!text-dark3 !no-underline hover:!underline"
                @click.native="handleDelete($event, option)"
              >
                Remove
              </BaseButton>
            </template>
          </ComboBox>
        </div>
      </div>
    </div>

    <div class="p-lg mb-lg bg-whiteOverride">
      <div class="flex gap-base">
        <div class="w-full">
          <h2>Without caret</h2>

          <ComboBox
            v-model="value"
            :options="options"
            :showCaret="false"
            placeholder="Start typing title to search for a Lorem Ipsum"
            noResults="Can't find that mate"
            data-ec=""
            data-et=""
          />
        </div>
        <div class="w-full">
          <h2>Narrow</h2>

          <ComboBox
            v-model="value"
            :options="options"
            :showCaret="false"
            placeholder="Start typing title to search for a Lorem Ipsum"
            noResults="Can't find that mate"
            class="w-1/2"
            data-ec=""
            data-et=""
          />
        </div>
      </div>
    </div>

    <div class="p-lg mb-lg bg-whiteOverride">
      <h2>Empty list</h2>

      <ComboBox
        @select="handleSelect"
        :options="[]"
        placeholder="Where'd everybody go?"
        noOptions="Nothing here for you pal!"
        class="w-1/2"
        data-ec=""
        data-et=""
      />
    </div>
  </div>
</template>

<script>
// @ts-check
import { defineComponent, ref } from 'vue';
import { faker } from '@faker-js/faker';

import ComboBox from '@/components/tailwind/forms/ComboBox';

import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default defineComponent({
  components: {
    ComboBox,
    BaseButton,
  },
  setup() {
    const value = ref();

    const options = ref(Array.from({ length: 10 }, (_, i) => ({
        label: faker.lorem.sentence(),
        value: i,
      })));

    function handleDelete(event, option) {
      event.preventDefault();
      event.stopPropagation();

      console.info(option, event);

      options.value.splice(
        options.value.findIndex(o => o.value === option.value),
        1,
      );
    }

    function handleSelect(event) {
      console.info(event);
    }

    return {
      value,
      options,
      handleDelete,
      handleSelect,
    };
  },
});
</script>
